import CasesPage from "../../shared-pages/read-only/hospital-and-cases/CasesPage";
import "antd/dist/antd.css";

const ManufacturerHospitalsCasePage = (props) => {
  const {
    match: { params },
  } = props;

  const { id: manufacturerId, hospitalid: hospitalId } = params;

  return (
    <CasesPage
      entity="manufacturer"
      entityId={manufacturerId}
      hospitalId={hospitalId}
    />
  );
};

export default ManufacturerHospitalsCasePage;
